import { showNotification } from '@mantine/notifications'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '..'

export const deleteEmailRecipient = (
  alertRuleId: string,
  recipientId: string,
) =>
  api.delete(`/v1/alert-rules/${alertRuleId}/email-recipients/${recipientId}`)

export const useDeleteEmailRecipient = (alertRuleId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (recipientId: string) =>
      deleteEmailRecipient(alertRuleId, recipientId),
    onSuccess: () => {
      queryClient.invalidateQueries([
        'alertRule',
        alertRuleId,
        'emailRecipients',
      ])
      showNotification({
        message: 'Email recipient removed successfully',
        color: 'green',
      })
    },
    onError: () => {
      showNotification({
        message: 'Failed to remove email recipient',
        color: 'red',
      })
    },
  })
}
